import React, { Component } from 'react';




class Footer extends Component {
   
    render() {
        return (
            <footer className="footer-area mt-5">
               
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-lg-3 res-margin">
                               
                                <div className="footer-items">
                                    
                                    <a className="navbar-brand" href="/">
                                        <img src='/img/logo-small.png' alt="logo" />
                                    </a>
                                   
                                    <p>SolReviews is the premier site for researching and reviewing Solana NFTs.</p>
                                    
                                    <div className="social-icons d-flex">
                                    <a className='discord'  href="https://www.discord.gg/qMFpQN2cDA" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-discord"></i>
                                                   
                                                </a>
                                    <a className='twitter'  href="https://www.twitter.com/BitWarriors_" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-twitter"></i>
                                                   
                                                </a>
                                    <a className='magic-eden'  href="https://magiceden.io/marketplace/bit_warriors" target="_blank" rel="noopener noreferrer">
                                    
                                    <img src='/img/magic-eden2.png' alt="logo" />
                                                </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3 res-margin">
                               
                                <div className="footer-items">
                                   
                                    <h4 className="footer-title">Useful Links</h4>
                                    <ul>
                                    <li ><a href="#">Profile</a></li>
                                    <li ><a href="/#explore">All projects</a></li>
                                    <li ><a href="#">login</a></li>
                                    <li ><a href="https://bitwarriors.app/">Raffles</a></li>
                                    <li ><a href="#">Privacy policy</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3 res-margin">
                              
                                <div className="footer-items">
                                   
                                    <h4 className="footer-title">Community</h4>
                                    <ul>
                                   
                                    <li ><a href="#">Partners</a></li>
                                    <li ><a href="#">FAQ</a></li>
                                   
                                    </ul>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                              
                                <div className="footer-items">
                                  
                                    <h4 className="footer-title">Subscribe</h4>
                                    
                                    <div className="subscribe-form d-flex align-items-center">
                                        <input type="email" className="form-control" placeholder="info@yourmail.com" />
                                        <button type="submit" className="btn"><i className="icon-paper-plane" /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                               
                                <div className="copyright-area d-flex flex-wrap justify-content-center justify-content-sm-between text-center py-4">
                                   
                                    <div className="copyright-left">©2022 NFT Review, All Rights Reserved.</div>
                                  
                                    <div className="copyright-right">Developed By Yung Money</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;